
<re-process-list  [columnsToIgnore]="['download']" (loaded)="load($event)"  title="Sync Legacy to IDM" description="This utility will import users from MatrixCare 360"></re-process-list>
